import { apiClient } from '@/lib/api-client'
import type { Collection } from '@/types/terms'

/** Selectable collections. Preview scratch collections are never returned. */
export async function getCollections(): Promise<Collection[]> {
  const { data } = await apiClient.get<{ collections: Collection[] }>('/collections')
  return data.collections ?? []
}

export async function createCollection(name: string, description = '') {
  const { data } = await apiClient.post<{ id: number; name: string; slug: string }>(
    '/collections',
    { name, description },
  )
  return data
}

export async function updateCollection(
  id: number,
  changes: { name?: string; description?: string },
) {
  const { data } = await apiClient.patch<{
    id: number
    name: string
    slug: string
    description: string
  }>(`/collections/${id}`, changes)
  return data
}

/** Destroys the documents, terms, concepts, stored PDFs and vector chunks too.
 *  The backend requires the collection's exact name back as confirmation. */
export async function deleteCollection(id: number, confirmName: string) {
  const { data } = await apiClient.delete<{
    status: string
    name: string
    documents_deleted: number
    chunks_deleted: number
  }>(`/collections/${id}`, { params: { confirm_name: confirmName } })
  return data
}
